<div>
    <button *ngIf="startupService.cart" mat-raised-button [routerLink]="['/secure/cart']"><ng-container i18n="@@Shopping Cart">ShoppingCart</ng-container><span> </span><mat-icon [matBadge]="startupService.cart.getItemsInCart()" matBadgeColor="warn">shopping_cart</mat-icon></button>
</div>
